// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\"> <path d=\"M193.29,41.65,71.88,185.55,1.11,118.83,25,93.53,69,135,166.71,19.22Z\" style=\"fill-rule:evenodd\"/> </svg>";
// Exports
module.exports = code;